import React from 'react'
import { useFormatMessage } from '@babylon/intl'
import { ButtonSimple, Text, EditorialLayout } from '@babylon/medkit'

import { Button } from '@babylon/web-platform-ui'
import { Header, Main, Footer } from '@/components'
import { useConfig } from '@/redux/partnerConfig/selectors'
import { URL_PREFIX } from '@/constants'
import errorImage from './error.svg'
import messages from './messages'
import styles from './ErrorPage.module.scss'

const ErrorPage = () => {
  const translate = useFormatMessage()
  const { partnerUrlSlug, useDnaV2Design } = useConfig()
  const rootUrl = `/${URL_PREFIX}/${partnerUrlSlug}`

  const goToHome = () => {
    window.location.href = rootUrl
  }

  return (
    <>
      <Header />
      <Main>
        <div className={styles.errorPageContainer}>
          <img src={errorImage} alt="" />
          <EditorialLayout>
            <Text variant="h1">{translate(messages.title)}</Text>
            <Text variant="body">{translate(messages.message1)}</Text>
            <Text variant="body">{translate(messages.message2)}</Text>
            {useDnaV2Design && (
              <Button onClick={goToHome} variant="primary">
                {translate(messages.action)}
              </Button>
            )}

            {!useDnaV2Design && (
              <ButtonSimple
                className={styles.errorPageButton}
                onClick={goToHome}
              >
                {translate(messages.action)}
              </ButtonSimple>
            )}
          </EditorialLayout>
        </div>
      </Main>
      <Footer />
    </>
  )
}

export default ErrorPage
